import React, {useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import {
  productSelector,
  enableThreeDViewer,
  disableThreeDViewer
} from "../../ducks/product";
import ThreeDRotationIcon from "@material-ui/icons/ThreeDRotationOutlined";
import Modal from "../../../common/Modal";
import ThreeDViewer from "../../../common/ThreeDViewer";
import Loader from "../../../common/Loader";

import styles from "./three-d-button.module.scss";

function ThreeDButton(props) {
  const {
    className,
    product: {show3d, loading}
  } = props;
  const [isOpen, setIsOpen] = useState(false);

  return show3d ? (
    <div className={classNames(className, styles.root)}>
      <div className={styles.button}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
          className={styles.title}
        >
          <span className={styles.icon}>
            <ThreeDRotationIcon />
          </span>
          <span className={styles.text}>просмотр</span>
        </a>
      </div>
      {isOpen && (
        <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
          <div className={styles.threeDViewer}>
            {loading && <Loader />}
            <ThreeDViewer
              enable={props.enableThreeDViewer}
              disable={props.disableThreeDViewer}
            />
          </div>
        </Modal>
      )}
    </div>
  ) : null;
}

ThreeDButton.propTypes = {
  product: PropTypes.object,
  enableThreeDViewer: PropTypes.func,
  disableThreeDViewer: PropTypes.func,
  className: PropTypes.string
};

export default connect(
  (state) => ({
    product: productSelector(state)
  }),
  {
    enableThreeDViewer,
    disableThreeDViewer
  }
)(ThreeDButton);
